import { anim, prog, pv, stagger } from '../../../../motion'
import { BeamBands, FitIcon } from '../../../../primitives'
import { DIMS, SCORE, fitOf } from '../../../demo/copy'
import { useCopy } from '../../../i18n'
import { MaskText, Odometer } from '../../stage/fx'

// Partikel formen die 82, danach baut sich der Report auf und eine Zeile wird zum Interview-Hinweis
const score = (w, h, narrow) => ({
  type: 'text',
  text: String(SCORE),
  x: narrow ? w / 2 : w * 0.7,
  y: narrow ? h * 0.36 : h * 0.5,
  size: narrow ? w * 0.62 : Math.min(h * 0.86, w * 0.4),
  dot: 0.9
})

export const SCORE_PARTICLES = [
  [0.04, score],
  [0.3, score],
  [0.42, () => ({ type: 'scatter', alpha: 0.16, seed: 37 })],
  [0.96, () => ({ type: 'scatter', alpha: 0.16, seed: 41 })]
]

const FOCUS = DIMS.findIndex((d) => d.key === 'math')

export default function DmsScore() {
  const c = useCopy('matching')
  const s = useCopy('show')
  const dims = useCopy('dims')

  return (
    <div className='sc-full'>
      <div className='dms-score-intro'>
        <div
          className='sc-eyebrow'
          style={anim({ at: [-1, 0], out: [0.34, 0.4] })}
        >
          {c.eyebrow}
        </div>
        <h2 className='sc-display'>
          <MaskText text={s.scoreTitle} at={[0.04, 0.12]} out={[0.34, 0.4]} />
        </h2>
        <div className='sc-h3 sc-grad'>
          <MaskText text={s.scoreSub} at={[0.12, 0.2]} out={[0.34, 0.4]} />
        </div>
        <div
          className='dms-pill'
          style={anim({ at: [0.18, 0.24], out: [0.34, 0.4], y: 20 })}
        >
          {c.scoreLabel}
        </div>
      </div>

      <div className='dms-report' style={prog([0.66, 0.76])}>
        <div
          className='dms-report__card sc-glass'
          style={anim({ at: [0.4, 0.48], y: 120, s: 0.92 })}
        >
          <div className='dms-report__top'>
            <span className='dms-report__name'>{c.report}</span>
            <span className='dms-report__legend'>
              <i className='dms-dot' /> {c.person}
              <i className='dms-swatch dms-swatch--ideal' /> {c.target}
              <i className='dms-swatch dms-swatch--trans' /> {c.tolerance}
            </span>
          </div>
          {DIMS.map((d, row) => (
            <div
              key={d.key}
              className='dms-report__row'
              style={{
                ...pv('h', [0.72, 0.78]),
                '--keep': row === FOCUS ? 1 : 0
              }}
            >
              <div className='dms-report__label'>
                {dims[d.key]}
                {d.must && <span className='dms-must'>{c.must}</span>}
              </div>
              <div className='dms-report__track'>
                <BeamBands
                  ideal={d.ideal}
                  trans={d.trans}
                  at={stagger(0.46, 0.025, 0.08, row)}
                />
                <div
                  className='cin-reason__pin'
                  style={{
                    ...prog(stagger(0.52, 0.025, 0.1, row)),
                    left: `calc(var(--p) * ${d.person}%)`
                  }}
                >
                  <div className='dms-report__marker' />
                </div>
              </div>
              <div
                style={anim({
                  at: stagger(0.6, 0.025, 0.04, row),
                  s: 0.3,
                  y: 0
                })}
              >
                <FitIcon fit={fitOf(d)} size={26} />
              </div>
              {row === FOCUS && <div className='dms-report__ring' />}
            </div>
          ))}
          <div
            className='dms-report__score'
            style={anim({ at: [0.6, 0.66], y: 20 })}
          >
            <div>
              <div className='dms-report__score-label'>{c.score}</div>
              <div className='dms-report__note'>{c.note}</div>
            </div>
            <Odometer
              value={String(SCORE)}
              at={[0.61, 0.68]}
              className='sc-num dms-report__num'
            />
          </div>
        </div>
      </div>

      <div className='dms-detail'>
        <div className='sc-h3' style={anim({ at: [0.74, 0.8], x: 60, y: 0 })}>
          {c.detailTitle}
        </div>
        <p
          className='dms-detail__text'
          style={anim({ at: [0.76, 0.82], x: 60, y: 0 })}
        >
          {c.detailText}
        </p>
        {c.hints.map((h, i) => (
          <div
            key={h.title}
            className={`dms-hint dms-hint--${i} sc-glass`}
            style={anim({ at: stagger(0.8, 0.04, 0.06, i), x: 80, y: 0 })}
          >
            <span className='dms-hint__icon'>{h.icon}</span>
            <div>
              <div className='dms-hint__title'>{h.title}</div>
              <div className='dms-hint__text'>{h.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
